import BaseStep from './BaseStep.js';

export default class TeamsFlows extends BaseStep{
    #teamAction;
	#teamGoal;
    #editingStep;

    _init() {
        this._MultiStepForms.Hook.addAction('addEvents', () => {
            this.#events()
        });

        this._MultiStepForms.Hook.addAction('addWatchers', () => {
            this.#watchers()
        });

        this._MultiStepForms.Hook.addAction('nextStep', (currentStep, nextStep, currentFormWrapper, nextFormWrapper) => {
            this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';

            if (!this.#teamAction) return;

            if (currentFormWrapper.classList.contains('team-select-step')) {

				const teamName = currentFormWrapper.querySelector('input[name="team_name"]')?.value || '';
				const src = currentFormWrapper.querySelector('input[name="team_featured_image"]')?.files[0] || '';

				if (teamName) {
					this.#saveTeamCardData(
						teamName,
						src ? URL.createObjectURL(src) : ''
					);
				}

				const currencySelect = this._MultiStepForms.formWrapper.querySelector('select[name="base_currency"]');

				if (currencySelect) {
					let teamGoal = this.#teamGoal || currentFormWrapper.querySelector('input[name="team_campaign_goal_other_amount"]')?.value || 0;
					teamGoal =  new Intl.NumberFormat().format(teamGoal);
					const currencySymbol = currencySelect.options[currencySelect.selectedIndex]?.dataset?.symbol || '';

					this._MultiStepForms.formWrapper.querySelectorAll('.form-group.campaign-currency .form-control-description')?.forEach(el => {
						if (el.innerHTML.includes('{{team_goal}}')){
							el.innerHTML = el.innerHTML.replace(
								'{{team_goal}}',
								`<span class="team-goal">${currencySymbol + teamGoal}</span>`);
						} else if (el.querySelector('.team-goal')) {
							el.querySelector('.team-goal').textContent = currencySymbol + teamGoal;
						}
					})
				}
            }

            this.#setTeamPreviewData();
        });

		this._MultiStepForms.Hook.addFilter('doPrevStep', (doPrevStep, currentStep, prevStep) => {
			if (this._MultiStepForms.currentStep === 2) {
				let urlObject = new URL(window.location.href);

				let referrer = urlObject.searchParams.get('referrer') || '';

				if (referrer){
					return false;
				}
			}
			return doPrevStep;
		});

        this._MultiStepForms.Hook.addAction('prevStep', (currentStep, prevStep, currentFormWrapper, prevFormWrapper) => {
            this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';

            if (this._MultiStepForms.currentStep === 2) {
                let urlObject = new URL(window.location.href);

                let referrer = urlObject.searchParams.get('referrer') || '';

                if (referrer) {
					urlObject.searchParams.delete('referrer');

					if (urlObject.pathname.endsWith('/participate/')) {
						urlObject.pathname += referrer;
					} else if (urlObject.pathname.includes('/participate/')) {
						const pathArray = urlObject.pathname.split('/').filter(e => e);
						pathArray.pop();

						urlObject.pathname = '/' + pathArray.join('/') + '/' + referrer + '/';
					}

					window.location = urlObject.toString();
					return;
				}
            }
        });

        this._MultiStepForms.Hook.addAction('goToStep', (currentStep, prevStep, currentFormWrapper, prevFormWrapper) => {
            this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';

            if (this._MultiStepForms.currentStep === 2) {
                let urlObject =  new URL(window.location.href);

                let referrer = urlObject.searchParams.get('referrer') || '';

                if (referrer) {
                    urlObject.searchParams.delete('referrer');
                }
            }
        });

        this._MultiStepForms.Hook.addAction('identFormsSubmit', (form, formAction, forms) => {
            if (this.#editingStep) {
                this._MultiStepForms.childClasses.ManageSteps.goToStep(this.#editingStep);
            }
        });

        this._MultiStepForms.Hook.addFilter('doNextStep', (doNextStep, currentStep, nextStep) => {
			if (this.#editingStep) {
				const teamName = this._MultiStepForms.formWrapper.querySelector('input[name="team_name"]')?.value || '';
				const src = this._MultiStepForms.formWrapper.querySelector('input[name="team_featured_image"]')?.files[0] || '';

				if (teamName) {
					this.#saveTeamCardData(
						teamName,
						src ? URL.createObjectURL(src) : ''
					);
				}

				if (this.#editingStep === this._MultiStepForms.currentStep){
					this.#editingStep = null;
				}

				this.#setTeamPreviewData();

                return false;
            }

            return doNextStep;
        }, 5);

        this._MultiStepForms.Hook.addAction('fieldEdit', (fieldsContainer, button) => {
            if (fieldsContainer.classList.contains('preview') && fieldsContainer.classList.contains('team')) {
                this.#editingStep = this._MultiStepForms.currentStep;

                const editStepForm = this._MultiStepForms.formWrapper.querySelector('.team-select-step');

                if (!editStepForm) return;

                const editStep = this._MultiStepForms.formSteps.indexOf(editStepForm) + 1 || 0;

                this._MultiStepForms.childClasses.ManageSteps.goToStep(editStep);
            }
        })
    }

    #watchers() {
        this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';
    }

    #events() {
        this.#saveTeamCardData();

        this._MultiStepForms.handleEvent('click', 'button[name="action"][value="next-step"]', (event, button) => {
             event.preventDefault();

             const form = button.closest('form');

             form?.querySelector('.submit-form')?.click();
        });

        this.#initSearch();

        this.#initTeamSelect();
    }

    #initSearch(){
        let typing = false;
        let typingTimeout;

        this._MultiStepForms.handleEvent('input', 'form input[type="search"][data-action]:not([disabled])', (event, field) => {

            typing = true;

            clearTimeout(typingTimeout);

            typingTimeout = setTimeout(()=>{
                if (typing) {
                    typing = false;

                    const searchResultsWrapper = field.closest('form')?.querySelector('.search-results[data-search="' + field.id + '"]');

                    if (!searchResultsWrapper) return;

                    const searchForm = document.createElement('form');

                    if (field.value) {

                        searchForm.innerHTML = `
                            <input type="text" name="action" value="${field.dataset.action}">
                            <input type="text" name="search" value="${field.value}">
                            `;

                        const additionalFields = JSON.parse(field.dataset?.additionalFields || '{}');

                        for (const name in additionalFields){
                            searchForm.innerHTML += `<input type="text" name="${name}" value="${additionalFields[name]}">`;
                        }

                        if(field.dataset.action === 'find_teams'){
                            searchResultsWrapper.innerHTML = "<span class='signup-form-loader'></span>";
                        }

                        this._MultiStepForms.submitForm(searchForm, field.dataset.action, false)
                            .then(response => {
                                searchResultsWrapper.innerHTML = response?.results?.html || '';
                            })
                            .catch(response => {
                                if (response?.message) {
                                    this._MultiStepForms.error(null, response.message);
                                }

                                if (response?.results) {
                                    searchResultsWrapper.innerHTML = response.results?.html || '';
                                }
                            });
                    } else {
                        searchResultsWrapper.innerHTML = '';
                    }
                }
            }, 600);

        })
    }

    #initTeamSelect() {
        this._MultiStepForms.handleEvent('click', '.team-card', (event, card) => {
            const form = card.closest('form');

            card.classList.toggle('is-selected');

            const isSelected = card.classList.contains('is-selected');

            const allCards = form.querySelectorAll('.team-card');

            if (allCards) {
                allCards.forEach(c => {
                    if (c !== card && c.classList.contains('is-selected')) {
                        c.classList.remove('is-selected');
                    }
                });
            }

            const teamIdFiled = form.querySelector('input[name="team_id"]');

            if (teamIdFiled){
                teamIdFiled.value = isSelected ? card.dataset.value : '';
            }

            if (isSelected) {
                this.#saveTeamCardData(
                    card.querySelector('.title')?.textContent || '',
                    card.querySelector('img')?.src || '',
                    card.dataset?.value || 0
                );

				this.#teamGoal = +card?.dataset?.goal || 0;
			} else {
                this.#saveTeamCardData();
				this.#teamGoal = 0;
            }

            const elementsForCreateTeam = this._MultiStepForms.formWrapper.querySelectorAll('.create-team');

            if (elementsForCreateTeam){
                elementsForCreateTeam.forEach(el => {
                    el.style.display = isSelected ? 'none' : '';

                    if (el.querySelector('input,textarea,select')) {
                        el.querySelector('input,textarea,select').disabled = isSelected;
                    }
                });
            }

        });
    }

    #saveTeamCardData(teamName = '', src = '', id = 0) {
        this._MultiStepForms.setCookie('team_card_data', JSON.stringify({
            name: teamName,
            image_src: src,
            id: id
        }));
    }

    #setTeamPreviewData() {
        if (!this.#teamAction || this.#teamAction === 'join-campaign') return;

        const cardData = this.#getTeamCardData();

        if (!cardData) return;

        this._MultiStepForms.formWrapper.querySelectorAll('.preview.team')?.forEach(preview => {
            const texts = preview.querySelector('.texts');

            if (preview.querySelector('.team-name')){
                preview.querySelector('.team-name').textContent = cardData.name;
            }

            if (preview.querySelector('input[name=team_id]')){
                preview.querySelector('input[name=team_id]').value = cardData.id;
            }

            texts.innerHTML = `
                <div class="img-wrapper">
                    <img src="${cardData.image_src || ''}" alt="">
                </div>
                <div class="content">
                    <p class="subtitle">${this.#teamAction === 'create-team' ? wp.i18n.__('I am the team captain for:', 'levcharity') : wp.i18n.__('I am a runner for:', 'levcharity')}</p>
                    <p class="title">${cardData.name}</p>
                </div>
                `;
        });

        const thank_you_team_card = this._MultiStepForms.formWrapper.querySelector('.thank-you-step .team-card');

        if (!thank_you_team_card) return;

        thank_you_team_card.innerHTML = `
                <div class="img-wrapper">
                    <img src="${cardData.image_src || ''}" alt="">
                </div>
                <div class="content">
                    <p class="subtitle">${wp.i18n.__('You have joined:', 'levcharity')}</p>
                    <p class="title">${cardData.name}</p>
                </div>`;
    }

    #getTeamCardData() {
        let cardData = this._MultiStepForms.getCookie('team_card_data');

        if (!cardData) return {};

        try {
            cardData = JSON.parse(cardData);

            if (!cardData) return {};
        } catch (e) {
            if (typeof cardData !== 'object') return; {}
        }

        return cardData;
    }
}
